var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { contains, update, path } from 'ramda';
import { Button } from 'primereact/button';
import { FormBaseElement, XbpmContext, ExtraActionType } from '@unitarius/xbpm-runtime';
import { ControlError } from './ControlError';
import { mapElementClass } from '../../common';
var FileList = /** @class */ (function (_super) {
    __extends(FileList, _super);
    function FileList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isPDF = function (mimeType) { return contains('pdf', mimeType); };
        _this.getIcon = function (mimeType) {
            if (contains('zip', mimeType) || contains('rar', mimeType)) {
                return 'far fa-file-archive';
            }
            if (contains('doc', mimeType)) {
                return 'far fa-file-word';
            }
            if (_this.isPDF(mimeType)) {
                return 'far fa-file-pdf';
            }
            if (contains('image', mimeType)) {
                return 'far fa-file-image';
            }
            if (contains('text', mimeType)) {
                return 'far fa-file-alt';
            }
            return 'far fa-file';
        };
        _this.displayFile = function (file) { return __awaiter(_this, void 0, void 0, function () {
            var fileService, src, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fileService = XbpmContext.getContext().getProvider('fileService');
                        this.onBusy(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fileService.getFileUrl({ url: "/attachments/" + file.linkId, headers: this.headers })];
                    case 2:
                        src = _b.sent();
                        window.open(src, '_blank');
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.onError('Произошла ошибка при попытке получения файла.');
                        return [3 /*break*/, 4];
                    case 4:
                        this.onBusy(false);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.downloadFile = function (file) { return __awaiter(_this, void 0, void 0, function () {
            var fileService, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fileService = XbpmContext.getContext().getProvider('fileService');
                        this.onBusy(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fileService.getFile({ url: "/attachments/" + file.linkId, headers: this.headers }, file.fileName)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        this.onError('Произошла ошибка при попытке получения файла.');
                        return [3 /*break*/, 4];
                    case 4:
                        this.onBusy(false);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.removeFile = function (idx, file) {
            var next = update(idx, file, _this.value || []);
            _this.handleChange(next);
        };
        return _this;
    }
    Object.defineProperty(FileList.prototype, "headers", {
        get: function () {
            return path(['def', 'frontOptions', 'headers'], this.state);
        },
        enumerable: false,
        configurable: true
    });
    FileList.prototype.elementRender = function (def) {
        var _this = this;
        var _a = def.frontOptions, hint = _a.hint, label = _a.label, restOptions = __rest(_a, ["hint", "label"]);
        var items = Array.isArray(this.value) ? this.value : [];
        var title = label || def.label;
        return def.hidden ? (null) : React.createElement("div", { className: mapElementClass(restOptions) },
            title && React.createElement("label", null, title),
            React.createElement("div", null, items.map(function (it, idx) { return (it.isActual && React.createElement("div", { className: 'p-buttonset', key: it.linkId },
                React.createElement(Button, { label: it.fileName, className: 'p-justify-start p-button-outlined p-button-secondary', icon: _this.getIcon(it.mimeType || ''), onClick: function () { return _this.downloadFile(it); } }),
                _this.isPDF(it.mimeType) && React.createElement(Button, { icon: 'far fa-eye', onClick: function () { return _this.displayFile(it); } }),
                !def.disabled && React.createElement(Button, { icon: 'far fa-trash-alt', onClick: function () { return _this.removeFile(idx, __assign(__assign({}, it), { isActual: false })); } }))); })),
            React.createElement(ControlError, { error: this.error, touched: this.touched }));
    };
    FileList.prototype.onBusy = function (loading) {
        this.props.onEvent({ type: ExtraActionType.LOADING, target: this.state.def, data: loading });
    };
    FileList.prototype.onError = function (data) {
        this.props.onEvent({ type: ExtraActionType.ERROR, target: this.state.def, data: data });
    };
    return FileList;
}(FormBaseElement));
export { FileList };
//# sourceMappingURL=FileList.js.map